import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SdsHeaderComponent } from '@alta-lib/components/layout/header/alta.header.componente';
import { SdsFooterComponent } from '@alta-lib/components/layout/footer/alta.footer.componente';
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SdsHeaderComponent, SdsFooterComponent],
  template: `
    <alta-header></alta-header>
    <main>
      <router-outlet></router-outlet>
    </main>
    <alta-footer></alta-footer>
    <a href="https://wa.me/556492097848?text=Olá!%20Gostaria%20de%20conversar%20sobre%20um%20projeto" 
       target="_blank"
       rel="noopener noreferrer"
       class="floating-chat-button"
       aria-label="Fale conosco no WhatsApp">
      <span class="material-symbols-outlined">chat</span>
    </a>
  `,
  styleUrls: ['./alta.app.componente.scss']
})
export class AppComponent implements OnInit {
  title = 'Alta Sistemas';
  private themeService = inject(ThemeService);

  constructor(private router: Router) {
    // Initialize theme on app startup
    this.themeService.initTheme();
  }

  ngOnInit(): void {
    // Scroll to top on route change
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo(0, 0);
    });
  }
}



